import {
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  Component,
  TemplateRef,
  ChangeDetectorRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DatiDecretoManualiVO } from "@app/shared/vo/dati-decreto-manualiVO";

@Component({
  selector: "app-modale-aggiungi-dati-decreto",
  templateUrl: "./modale-aggiungi-dati-decreto.component.html",
})
export class ModaleAggiungiDatiDecretoComponent implements OnInit {
  @ViewChild("aggiungiDatiDecretoModal", { static: false })
  public aggiungiDatiDecretoModal: TemplateRef<any>;

  @Output()
  emettiDatiDecreto: EventEmitter<
    DatiDecretoManualiVO
  > = new EventEmitter<any>();

  datiDecreto: DatiDecretoManualiVO = new DatiDecretoManualiVO();

  private config = {
    class: "modal-dialog modal-info modal-xlg",
    animated: true,
  };

  public modalRef: BsModalRef;

  public formDecreto: FormGroup;


  public modaleAperta: boolean;


  public formDatiDecreto: FormGroup;

  ngOnInit(): void { }

  constructor(
    private modalService: BsModalService,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
  }

  public openModal(datiIniziali?: DatiDecretoManualiVO) {
    this.modaleAperta = false;
    this.modalRef = this.modalService.show(
      this.aggiungiDatiDecretoModal,
      this.config
    );
    this.formDatiDecreto = this.fb.group({
      numero: [null, Validators.required],
      data: [null, Validators.required],
      oggetto: [null, Validators.required],
    });

    // Listener per formattare automaticamente la data quando viene selezionata
    this.formDatiDecreto.get('data').valueChanges.subscribe(dataValue => {
      if (dataValue) {
        const date = new Date(dataValue);

        // Ottieni i componenti della data completa
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // Costruisci il formato desiderato: YYYY-MM-DDTHH:mm:ss.062+01:00
        const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.062+01:00`;

        // Aggiorna il valore del form con la data formattata (senza triggering di nuovo il listener)
        this.formDatiDecreto.get('data').setValue(formattedDate, { emitEvent: false });
      }
    });

    if (datiIniziali) {
      this.formDatiDecreto.patchValue({
        numero: datiIniziali.numero || null,
        data: datiIniziali.dataConclusione ? new Date(datiIniziali.dataConclusione) : null,
        oggetto: datiIniziali.oggetto || null,
      });
    }

    this.modaleAperta = true;
    this.cd.detectChanges();
  }


  public chiudiModale() {
    this.modalRef.hide();
  }

  salva() {

    this.datiDecreto = new DatiDecretoManualiVO();
    this.datiDecreto.numero = this.formDatiDecreto.get("numero").value;
    this.datiDecreto.oggetto = this.formDatiDecreto.get("oggetto").value;
    this.datiDecreto.dataConclusione = this.formDatiDecreto.get("data").value;

    this.emettiDatiDecreto.emit(this.datiDecreto);

    this.chiudiModale();
  }

  annulla() {
    this.chiudiModale();
  }
}
